/**
 * Select descrittivo: per ogni opzione mostra "Etichetta" + descrizione lunga
 * sotto al campo selezionato (pattern descrittivo).
 *
 * Usa <select> nativo per semplicità/accessibilità; mostra il dettaglio
 * dell'opzione corrente come hint in cima.
 */
import { cn } from "@/lib/utils";
import type { RentriChoice } from "@/lib/rentriChoices";
import { formatChoiceOption } from "@/lib/rentriChoices";

interface ChoiceSelectProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  options: RentriChoice[];
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  /** Se true mostra la descrizione dell'opzione selezionata sotto al campo. */
  showDescription?: boolean;
  /** Se false l'utente può lasciare il campo vuoto. */
  required?: boolean;
}

export function ChoiceSelect({
  id,
  value,
  onChange,
  options,
  placeholder,
  disabled,
  className,
  showDescription = true,
  required,
}: ChoiceSelectProps) {
  const selected = options.find((o) => o.value === value);

  return (
    <div className="space-y-1">
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        required={required}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm",
          "ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
      >
        {!required && (
          <option value="">{placeholder ?? "— Seleziona —"}</option>
        )}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {formatChoiceOption(opt)}
          </option>
        ))}
      </select>
      {showDescription && selected?.description && (
        <p className="text-[11px] leading-snug text-muted-foreground">
          <span className="font-mono text-[10px]">{selected.label}</span>{" "}
          {selected.description}
        </p>
      )}
    </div>
  );
}
